import { useRef } from 'react'

import { Alert, Box } from '@factorialco/deprecated-design-system'
import { RichTextEditorHandle } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { TextEditorWithMessageTemplates } from 'modules/ats/components/TextEditorWithMessageTemplates'

import { CreateInterviewData } from './CreateInterviewData'

interface Props {
  data: CreateInterviewData
  onDataChanged: (data: CreateInterviewData) => void
}

export const isMessageCompleted = (data: CreateInterviewData) => !!data.messageContent

export const MessageStep = ({ data, onDataChanged }: Props) => {
  const richTextEditorRef = useRef<RichTextEditorHandle>(null)

  const onFilesChange = (files: File[] | null | undefined) => {
    onDataChanged({
      ...data,
      messageAttachments: files ?? [],
    })
  }

  return (
    <Box gap="s16">
      <TextEditorWithMessageTemplates
        value={data.messageContent || ''}
        onChange={(value) => {
          onDataChanged({
            ...data,
            messageContent: value || '',
          })
        }}
        onFiles={onFilesChange}
        placeholder={i18n.t('ats.schedule_interview.steps.message.start_typing')}
        richTextEditorRef={richTextEditorRef}
      />
      <Alert>{i18n.t('ats.schedule_interview.steps.message.attach_alert')}</Alert>
    </Box>
  )
}
